// extracted by mini-css-extract-plugin
module.exports = {"masthead":"Masthead__masthead___1HQbo","mobile":"Masthead__mobile___1jCbt"};